export const ENGINE_TYPES = {
  HYBRID: 'hybrid',
  ELECTRIC: 'electric',
  MILD_HYBRID: 'mild hybrid',
  PLUG_IN_HYBRID: 'plug-in hybrid',
};
